const css = `.ticket-detail-content .ticket-header-section-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 16px;
}
.ticket-detail-content .ticket-header-section-skeleton .ticket-title-section-skeleton {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.ticket-detail-content .ticket-header-section-skeleton .ticket-title-section-skeleton .type-icon-skeleton {
  flex-shrink: 0;
}
.ticket-detail-content .ticket-header-section-skeleton .ticket-title-section-skeleton .title-skeleton {
  flex: 1;
}
.ticket-detail-content .ticket-header-section-skeleton .status-badge-skeleton {
  flex-shrink: 0;
}
.ticket-detail-content .ticket-description-section-skeleton {
  margin: 24px 0;
}
.ticket-detail-content .ticket-description-section-skeleton .section-title-skeleton {
  margin-bottom: 16px;
}
.ticket-detail-content .ticket-description-section-skeleton .mb-2 {
  margin-bottom: 8px;
}
.ticket-detail-content .ticket-attachments-section-skeleton {
  margin: 24px 0;
}
.ticket-detail-content .ticket-attachments-section-skeleton .section-title-skeleton {
  margin-bottom: 16px;
}
.ticket-detail-content .ticket-attachments-section-skeleton .attachments-list-skeleton {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}
.ticket-detail-content .ticket-info-section-skeleton {
  margin: 24px 0;
}
.ticket-detail-content .ticket-info-section-skeleton .section-title-skeleton {
  margin-bottom: 16px;
}
.ticket-detail-content .ticket-info-section-skeleton .ticket-info-grid-skeleton {
  display: grid;
  grid-template-columns: repeat(auto-fit, 200px);
  gap: 16px;
}
.ticket-detail-content .ticket-metadata-section-skeleton {
  margin: 24px 0;
}
.ticket-detail-content .ticket-metadata-section-skeleton .mb-2 {
  margin-bottom: 8px;
}
.ticket-detail-content .ticket-comments-section-skeleton {
  margin-top: 24px;
}
.ticket-detail-content .ticket-comments-section-skeleton .section-title-skeleton {
  margin-bottom: 16px;
}
.ticket-detail-content .ticket-comments-section-skeleton .comments-list-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.ticket-detail-content .ticket-comments-section-skeleton .comments-list-skeleton .comment-item-skeleton {
  padding: 16px;
  border-radius: 8px;
  background-color: var(--surface-50);
}
.ticket-detail-content .ticket-comments-section-skeleton .comments-list-skeleton .comment-item-skeleton .comment-header-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
}
.ticket-detail-content .ticket-comments-section-skeleton .comments-list-skeleton .comment-item-skeleton .comment-header-skeleton .comment-author-skeleton {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ticket-detail-content .ticket-comments-section-skeleton .comments-list-skeleton .comment-item-skeleton .mb-2 {
  margin-bottom: 8px;
}
.ticket-detail-content .ticket-comments-section-skeleton .add-comment-section-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}
.ticket-detail-content .ticket-comments-section-skeleton .add-comment-section-skeleton .mb-2 {
  margin-bottom: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
